export default __webpack_public_path__ + "static/media/T340_CoC.a9c94edb.pdf";